import React from "react";
import "./CustomLoader.css";

export default function CustomLoader() {
  return (
    <div className="loader-overlay">
      <div className="loader-container">

        <div className="pulse-ring"></div>
        <div className="pulse-ring pulse-ring-2"></div>

        <div className="logo-wrapper">
          <img
            src="/assets/img/a1-img/Logo.png"
            alt="A1 Bakery"
            className="loader-logo"
          />
        </div>

      </div>
    </div>
  );
}